import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastProvider } from './contexts/ToastContext';
import { SnapshotProvider } from './contexts/SnapshotContext';

// Pages
import { Landing } from './pages/Landing';
import { Preview } from './pages/Preview';
import { Invite } from './pages/Invite';
import { Checkout } from './pages/Checkout';
import { Assessment } from './pages/Assessment';
import { Results } from './pages/Results';
import { RefundPolicy } from './pages/RefundPolicy';
import { About } from './pages/About';
import { NotFound } from './pages/NotFound';

// Admin Pages
import { AdminLogin } from './pages/admin/AdminLogin';
import { AdminDashboard } from './pages/admin/AdminDashboard';

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <SnapshotProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/preview" element={<Preview />} />
            <Route path="/i/:inviteToken" element={<Invite />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/assessment" element={<Assessment />} />
            <Route path="/results" element={<Results />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/*" element={<AdminDashboard />} />

            {/* Legal Pages */}
            <Route path="/refunds" element={<RefundPolicy />} />
            <Route path="/about" element={<About />} />

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </SnapshotProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
